<script>
  import BPMNModeler from "bpmn-js/lib/Modeler.js";
  import "bpmn-js/dist/assets/bpmn-js.css";
  import "bpmn-js/dist/assets/diagram-js.css";
  import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
  import "bpmn-js-properties-panel/dist/assets/properties-panel.css";
  import "bpmn-js-properties-panel/dist/assets/element-templates.css";
  import "lib/styles/bpmncomments.css";
  import "bpmn-js-embedded-comments/assets/comments.css";
  import {
    BpmnPropertiesPanelModule,
    BpmnPropertiesProviderModule,
  } from "bpmn-js-properties-panel";
  import resizeTask from "bpmn-js-task-resize/lib";
  import download from "downloadjs";
  import EmbeddedComments from "bpmn-js-embedded-comments";
  import { onMount, onDestroy } from "svelte";
  import { TreeView, Modal } from "carbon-components-svelte";

  import callActivityProperties from "./callActivityProperties";

  import callActivityExtension from "./callActivityProperties/callActivityExtension.json";
  import { modelercallActivity } from "lib/stores.js";
  import CallActivityDrilldownModule from "./drilldown";

  import { fly } from "svelte/transition";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { Session } from "svelte-session-manager";

  import collaborationNameProvider from "./collaborationName";

  import documentsPropertiesProviderModule from "./documents/provider";
  import documentsModdleDescriptor from "./documents/descriptors/documents";

  import itsystemsPropertiesProviderModule from "./itsystems/provider";
  import itsystemsModdleDescriptor from "./itsystems/descriptors/itsystems";

  import peoplePropertiesProviderModule from "./people/provider";
  import peopleModdleDescriptor from "./people/descriptors/people";

  import commentsPropertiesModule from "./comments/provider";
  import commentsModdleDescriptor from "./comments/descriptors/comments";
  import { jwtDecode } from "jwt-decode";
  import { currentSelectedModel } from "lib/stores.js";
  import { jsPDF } from "jspdf";
  import "svg2pdf.js";

  let session = new Session(localStorage);
  export let folderid;
  export let children;
  export let processid;
  export let processStructure;
  export let subprocessid;
  export let modeler;
  export let saveAction;
  export let uploadAction;
  export let downloadAction;

  let viewdiv;
  let propertydiv;
  let processname = "New Process";
  let canvas;
  let currentProcess = {};
  let currentSubprocessId = "";
  let selectedProcessId = [];
  export let unsafedChanges = false;

  const decoded = jwtDecode(session.authorizationHeader.Authorization || "");

  $: currentSubprocessId = $modelercallActivity.value;

  function updateBPMN() {
    fetchWithSession(`/api/pman/processModel/${processid}`)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          currentProcess = data;
          processname = data.name;
          try {
            if (data.bpmnstring) {
              modeler.importXML(data.bpmnstring).then(() => {
                if (subprocessid) {
                  canvas.setRootElement(
                    canvas.findRoot(subprocessid + "_plane")
                  );
                }
              });
              currentSelectedModel.set(modeler);
              modeler.get("editorActions")._actions.handTool();
            } else
              modeler.importXML(
                `<?xml version="1.0" encoding="UTF-8"?> <bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" id="Definitions_1is13ea" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="10.2.0"> <bpmn:process id="Process_1d2ydle" isExecutable="false"  name="${processname}"/> <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1d2ydle" /></bpmndi:BPMNDiagram> </bpmn:definitions>`
              );
          } catch (e) {
            throw new Error("Error. Check if diagram name is set!");
          }
        }
      });
  }

  $: {
    if ((processid || subprocessid) && modeler) updateBPMN();
  }

  function initalizeModeler() {
    modeler = new BPMNModeler({
      container: viewdiv,
      keyboard: { bindTo: document },
      propertiesPanel: {
        parent: propertydiv,
      },
      additionalModules: [
        CallActivityDrilldownModule,
        BpmnPropertiesPanelModule,
        BpmnPropertiesProviderModule,
        EmbeddedComments,
        callActivityProperties,
        resizeTask,
        documentsPropertiesProviderModule,
        itsystemsPropertiesProviderModule,
        peoplePropertiesProviderModule,
        commentsPropertiesModule,
        collaborationNameProvider,
        {
          __depends__: [],
          __init__: ["autoScroll"],
          autoScroll: ["value", null],
        },
      ],
      moddleExtensions: {
        callActivityExtension,
        documentsModdleDescriptor,
        itsystemsModdleDescriptor,
        peopleModdleDescriptor,
        commentsModdleDescriptor,
      },
      taskResizingEnabled: true,
      eventResizingEnabled: true,
    });
    canvas = modeler.get("canvas");
    modeler.get("eventBus").on("commandStack.changed", function (event) {
      unsafedChanges = true;
    });
  }

  async function saveBMPN() {
    try {
      var result = await modeler.saveXML({ format: true });
      const res = await fetchWithSession(`/api/pman/saveProcessModel`, {
        method: "POST",
        body: JSON.stringify({
          id: processid,
          bpmnstring: result.xml,
        }),
      });
      let response = await res.json();
      if (response.status == "success") {
        unsafedChanges = false;
        processStructure = response.process.processstructure;
      }
    } catch (err) {
      throw new Error("Error. Check if diagram name is set!");
    }
  }
  saveAction = saveBMPN;

  uploadAction = () => {
    bpmnuploader.click();
  };

  async function exportBPMN(type) {
    if (type === "bpmn") {
      modeler.saveXML({ format: true }).then((result) => {
        download(result.xml, `${processname}.bpmn`, "text/plain");
      });
    } else if (type === "svg") {
      modeler.saveSVG().then((result) => {
        download(result.svg, `${processname}.svg`, "image/svg+xml");
      });
    } else if (type === "pdf" || type === "print") {
      const doc = new jsPDF("l", "mm", [297, 210]);
      const svg = await modeler.saveSVG();
      const element = document.createElement("svg");
      element.innerHTML = svg.svg;
      if (type === "print") {
        doc.autoPrint();
        doc
          .svg(element.children[0], {
            x: 10,
            y: 10,
            width: doc.internal.pageSize.width - 20,
            height: doc.internal.pageSize.height - 20,
          })
          .then(() => {
            doc.output("dataurlnewwindow");
          });
      } else {
        doc
          .svg(element.children[0], {
            x: 10,
            y: 10,
            width: doc.internal.pageSize.width - 20,
            height: doc.internal.pageSize.height - 20,
          })
          .then(() => {
            doc.save(`${processname}.pdf`);
          });
      }
    }
  }
  downloadAction = exportBPMN;

  function handleBPMNModel(e) {
    var reader = new FileReader();
    reader.onload = function (event) {
      let bpmnProcess = event.target.result;

      let regex = /name="([^"]*)"/;
      let updatedBpmnProcess = bpmnProcess;
      if (regex) {
        updatedBpmnProcess = bpmnProcess.replace(
          regex,
          `name="${processname}"`
        );
      }

      modeler.importXML(updatedBpmnProcess);
    };
    reader.readAsText(bpmnuploader.files[0]);
  }

  let deleteBPMNModal = false;
  let clearBPMNModal = false;

  function clearBPMN() {
    modeler.importXML(
      `<?xml version="1.0" encoding="UTF-8"?> <bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" id="Definitions_1is13ea" targetNamespace="http://bpmn.io/schema/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="10.2.0"> <bpmn:process id="Process_1d2ydle" isExecutable="false"  name="${processname}"/> <bpmndi:BPMNDiagram id="BPMNDiagram_1"><bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1d2ydle" /></bpmndi:BPMNDiagram> </bpmn:definitions>`
    );
    clearBPMNModal = false;
  }

  function searchTree(root, searchid) {
    let process;
    if (root) {
      root.forEach((element) => {
        if (!process) {
          if (element.id == searchid) process = element;
          else if (element.children)
            process = searchTree(element.children, searchid);
        }
      });
    }
    return process;
  }

  function deleteBPMN() {
    fetchWithSession(`/api/pman/deleteProcessModel`, {
      method: "POST",
      body: JSON.stringify(currentProcess),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          let parentFolder = searchTree(children, currentProcess.folderid);
          if (parentFolder) {
            folderid = currentProcess.folderid;
            parentFolder.children = parentFolder.children.filter(
              (element) => element.id != currentProcess.id
            );
          } else {
            folderid = children[0].id;
          }
          children = children;
          deleteBPMNModal = false;
        }
      });
  }

  function changeSubprocessValue() {
    let elementRegistry = modeler.get("elementRegistry");
    let element = elementRegistry.get($modelercallActivity.id);
    element.businessObject.subprocessURL = selectedProcessId[0];
    document.getElementById(
      `properties_panel_input_${$modelercallActivity.id}`
    ).value = selectedProcessId[0];
    document.getElementById(
      `properties_panel_link_${$modelercallActivity.id}`
    ).href = `/app/pman/?idprocess=${selectedProcessId[0]}`;
    modelercallActivity.set({ open: false });
  }

  let bpmnuploader;

  let isSubprocess = false;
  function checkSubprocess() {
    if (canvas) {
      if (
        canvas["_rootElement"] &&
        canvas["_rootElement"]["type"] == "bpmn:Process"
      ) {
        isSubprocess = false;
      } else {
        isSubprocess = true;
      }
    }
  }

  function checkShortcut(e) {
    if (
      (window.navigator.userAgent.includes("Mac") ? e.metaKey : e.ctrlKey) &&
      e.keyCode == 83
    ) {
      saveBMPN();
      e.preventDefault();
    }
    if (
      (window.navigator.userAgent.includes("Mac") ? e.metaKey : e.ctrlKey) &&
      e.keyCode == 80
    ) {
      exportBPMN("print");
      e.preventDefault();
    }
  }

  onMount(() => {
    initalizeModeler();
    window.addEventListener("keydown", checkShortcut, false);
  });

  onDestroy(() => {
    window.removeEventListener("keydown", checkShortcut, false);
  });
</script>


<div class="modeler_wrapper">
  <input
    type="file"
    accept=".bpmn"
    on:change={handleBPMNModel}
    bind:this={bpmnuploader}
    style="display:none"
  />
  <div
    class="modeler_canvas"
    bind:this={viewdiv}
    style="display:inline-block"
  />
  <div class="modeler_info" bind:this={propertydiv} />
</div>

<Modal
  size="lg"
  kind="danger"
  open={clearBPMNModal}
  modalHeading="Clear Process Model?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    clearBPMNModal = false;
  }}
  on:open
  on:close={() => {
    clearBPMNModal = false;
  }}
  on:submit={clearBPMN}
>
  Warning: This will clear all parent and child processes!
  <br />
  This will take effect once the process model is saved.
</Modal>

<Modal
  size="lg"
  kind="danger"
  open={deleteBPMNModal}
  modalHeading="Delete Process?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    deleteBPMNModal = false;
  }}
  on:open
  on:close={() => {
    deleteBPMNModal = false;
  }}
  on:submit={deleteBPMN}
>
  Warning: This will delete all parent and child processes!
  <br />
  This can not be undone!
</Modal>

<Modal
  size="lg"
  open={$modelercallActivity.open}
  modalHeading="Chose Process"
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    modelercallActivity.set({ open: false });
  }}
  on:open
  on:close={() => {
    modelercallActivity.set({ open: false });
  }}
  on:submit={changeSubprocessValue}
>
  <TreeView bind:children bind:selectedIds={selectedProcessId} />
</Modal>

<style>
  :global(.comment-header) {
    padding: 0 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1c1c20;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  :global(.comment-message) {
    color: #1c1c20;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 1.125rem 0.75rem;
  }

  :global(.dull-view) {
    opacity: 50%;
  }

  :global(.comment-divider) {
    width: 100%;
    padding: 1rem 0.75rem;
  }
  :global(.comment-divider div) {
    height: 1px;
    background: #d9d9d9;
    width: 100%;
  }

  :global(.comment-text-area) {
    padding: 1rem;
  }

  :global(#comment-textarea) {
    border: 1px solid #dedede !important;
    resize: none;
  }

  :global(.comment-btn) {
    padding: 0 0.75rem;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  :global(.comment-btn button) {
    color: #ff5f1f;
    text-align: right;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
  }

  :global(.comment-add-btn) {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 0 0.75rem 1rem 0;
    gap: 4px;
  }

  :global(.comment-footer) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  :global(.comment-solved) {
    display: flex;
    align-items: center;
    color: rgba(40, 40, 40, 0.5);

    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 700 !important;
    gap: 3px;
    margin-left: 8px;
  }

  :global(.comment-add-btn button) {
    border-radius: 5px;
    background: #1c1c20;
    padding: 0.625rem;
    color: #fff;

    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8.6px;
  }

  :global(.reply-container) {
    padding-left: 50px;
    color: #1c1c20;

    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    padding-bottom: 15px;
    display: flex;
    justify-content: space-around;
  }

  :global(.reply-header) {
    font-weight: 700 !important;
  }

  .modeler_wrapper {
    display: flex;
    gap: 1rem;
    max-width: calc(100% - 1rem);
    height: 100%;
    background-color: var(--pax-smoke);
    padding: 1rem;
  }

  .modeler_canvas {
    width: 80%;
    border-radius: 0.5rem;
    flex-grow: 1;
    background-color: var(--pax-white);
    display: inline-block;
  }

  .modeler_info {
    width: 20%;
    min-width: fit-content;
    max-width: 500px;
    border-radius: 0.5rem;
    display: inline-block;
    vertical-align: top;
    padding-top: 1rem;
    padding: 0.5rem;
    background-color: var(--pax-white);
    border-radius: 0.5rem;
  }
</style>
